import { render, staticRenderFns } from "./ClipboardText.vue?vue&type=template&id=58267ecd"
import script from "./ClipboardText.vue?vue&type=script&lang=js"
export * from "./ClipboardText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports